import { MF } from 'mass-tools';
import React from 'react';
import { Table } from 'react-bootstrap';
import { MF as ReactMF } from 'react-mf';

function ResultAnalysis({ analysis }) {
  let info = {};
  try {
    const mf = new MF(analysis, { ensureCase: true });
    info = mf.getInfo();
  } catch (e) {
    analysis = '';
  }
  let mass = info.mass;
  let formula = info.mf;
  let monoisotopicMass = info.monoisotopicMass;
  let observedMonoisotopicMass = info.observedMonoisotopicMass;
  let unsaturation = info.unsaturation;
  let charge = info.charge;
  let dataItem = info.atoms;
  let count = [];
  for (let key in dataItem) {
    count.push(dataItem[key]);
  }
  const mf = new MF(analysis, { ensureCase: true });
  let ea = mf.getEA();

  let molecularFormulaDetails = [];

  for (let i = 0; i < ea.length; i++) {
    molecularFormulaDetails[i] = (
      <tr>
        <td>{ea[i].element}</td>
        <td>{count[i]}</td>
        <td>{(ea[i].ratio * 100).toFixed(2)} % </td>
      </tr>
    );
  }
  let formulaMolecular = molecularFormulaDetails;
  const elementClassName = 'w-1/2 mb-1w md:mb-6';
  const resultClassName = 'font-bold text-2xl';
  return (
    <div className="flex flex-wrap text-center text-white">
      <div className={elementClassName}>
        <p>MOLECULAR FORMULA</p>
        <p className={resultClassName}>
          {formula ? <ReactMF mf={formula || ''} /> : '-'}
        </p>
      </div>
      <div className={elementClassName}>
        <p>MOLECULAR WEIGHT</p>
        <p className={resultClassName}>{mass ? mass.toFixed(2) : '-'}</p>
      </div>
      <div className={elementClassName}>
        <p>MONOISOTOPIC MASS</p>
        <p className={resultClassName}>
          {monoisotopicMass ? monoisotopicMass.toFixed(5) : '-'}
        </p>
      </div>
      <div className={elementClassName}>
        <p>UNSATURATION</p>
        <p className={resultClassName}>
          {unsaturation === undefined ? '-' : unsaturation}
        </p>
      </div>
      <div className={elementClassName}>
        <p>M/Z</p>
        <p className={resultClassName}>
          {observedMonoisotopicMass === undefined
            ? '-'
            : observedMonoisotopicMass.toFixed(5)}
        </p>
      </div>
      <div className={elementClassName}>
        <p>CHARGE</p>
        <p className={resultClassName}>{charge}</p>
      </div>
      <Table striped bordered hover className="bg-white mx-2 lg:mx-10 ">
        <thead>
          <tr>
            <th>ELEMENT</th>
            <th>MASS</th>
            <th>PERCENT</th>
          </tr>
        </thead>
        <tbody>{formulaMolecular}</tbody>
      </Table>
    </div>
  );
}

export default ResultAnalysis;
